import React from 'react';
import './PageHeader.scss';

const PageHeader = ({ bgImage, bgImageMobile, icon: Icon, title, titleNode, subtitle, description }) => (
  <div
    className={`page-header${description ? ' page-header--centered' : ''}`}
    style={{
      '--bg-desktop': `url(${bgImage})`,
      '--bg-mobile':  `url(${bgImageMobile || bgImage})`,
    }}
  >
    <div className="page-header__gradient" />
    <div className="page-header__inner">
      {Icon && <Icon className="page-header__icon" />}
      <div className="page-header__text">
        <h1 className="page-header__title">{titleNode || title}</h1>
        {subtitle && <p className="page-header__subtitle">{subtitle}</p>}
        {description && <p className="page-header__desc">{description}</p>}
      </div>
    </div>
  </div>
);

export default PageHeader;
